import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)`
  width: 100%;
`;
